// import {combineReducers} from "redux";
import Clients from './ClientsReducer';

// if there are more than one reducer in this component, use combineReducers
/*
const Clients = combineReducers({
    Clients
})
*/

export default Clients;
